import { Injectable } from '@angular/core';
import { IModalOptions } from "../../common/modals/modal-options.interface";
import { Observable, of } from "rxjs";
import { EcaModalOptions } from "../../shared/models/yesno-modal-options.class";
import { ICompanyEngagementHistory } from "../../message-models/company-engagement-history.interface";
import { IJobTitleInfo } from "../../message-models/job-title.interface";
import { IJobLevelInfo } from "../../message-models/job-level.interface";
import { IRiskInfo } from "../../message-models/risk-info.interface";
import { EngagementHistoryModalComponent } from "../components/engagement-history-modal/engagement-history-modal.component";
import { CompanyEngagementHistory } from "../../message-models/company-engagement-history.class";
import { IEmploymentStatus } from '../../message-models/employment-status.interface';
import { EcaDynamicModalService } from "../../shared/services/eca-dynamic-modal-service";
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IEcaDialogRef } from '../../shared/models/eca-dialog-ref.interface';
import { IOperativeTypeInfo } from '../../message-models/operative-type.interface';
import { IBusinessUnitInfo } from '../../message-models/business-unit.interface';
import { ICompanyJobTitle } from '../../message-models/company-job-title.interface';

@Injectable({
  providedIn: 'root'
})

export class EngagementModalService {
  engagementModalRef: IEcaDialogRef;

  constructor(private ecaDynamicModalService: EcaDynamicModalService) {
  }

  openEngagementEditorModal(heading: string,
    allJobTitles: IJobTitleInfo[],
    allCompanyJobTitles: ICompanyJobTitle[],
    allJobLevels: IJobLevelInfo[],
    allRisks: IRiskInfo[],
    allOperativeTypes: IOperativeTypeInfo[],
    allBusinessUnits: IBusinessUnitInfo[],
    allEmploymentStatuses: IEmploymentStatus[],
    isEditing: boolean = false,
    engagement?: ICompanyEngagementHistory,
    options?: IModalOptions): Observable<IEcaDialogRef> {
    if (options === undefined) {
      options = new EcaModalOptions();
      options.modalClasses += " modal-eca-success";
    }
    if (!engagement) {
      engagement = new CompanyEngagementHistory();
    }

    let config = {
      styleClass: 'modal-xl ' + options.modalClasses,
      baseZIndex: 2000,
      showHeader: false,
      data: {
        heading,
        allJobTitles,
        allCompanyJobTitles,
        allJobLevels,
        allRisks,
        allOperativeTypes,
        allBusinessUnits,
        allEmploymentStatuses,
        editing: isEditing,
        engagement: engagement,
      }
    } as DynamicDialogConfig;

    this.engagementModalRef = this.ecaDynamicModalService.openDialog(EngagementHistoryModalComponent, config);
    return of(this.engagementModalRef);
  }
}

